import { Component, OnInit } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { InwardStatus } from 'src/app/Enums/inwardEnum';
import { OutwardStatus } from 'src/app/Enums/outwardEnum';
import { AuditData } from 'src/app/shared/classes/AuditTrail';
import { ConstantsService } from 'src/app/shared/services/Constants/constants.service';
import { DataContextService } from 'src/app/shared/services/data-context.service';

@Component({
  selector: 'app-cancel-popup',
  templateUrl: './cancel-popup.component.html',
  styleUrls: ['./cancel-popup.component.css']
})
export class CancelPopupComponent implements OnInit {
  private unsubscribe$ = new Subject<void>();
  
  service_URL: any;
  count : number = 0;
  reason : string = '';
  selectedRequest: any;
  flag: boolean = true;
  emailId: string ='';

  constructor(
    private modalService: BsModalService,
    private _dataContextService: DataContextService,
    private toast: ToastrService
  ) {
    this.service_URL = ConstantsService;
  }

  ngOnInit(): void {
    this.emailId=localStorage.getItem('email');
  }

  Cancel() {
    this.modalService.hide(1);
    $('body').removeClass('modal-open');
  }

  showcount(reason : any){
    this.count = this.reason.length;
    if(this.reason !== '' && this.count > 0){
      this.flag = false;
    }
    else{
      this.flag = true;
    }
  }

  Submit(){
    let params = {
      statusId : 12,
      previousStatusId:12,
      requestId : this.selectedRequest.requestId,
      CancelledByNotes:this.reason,
      UpdatedBy:this.emailId
    }

    let auditData = [];

    let statusChangeAudit: AuditData = new AuditData();
    statusChangeAudit.changedAttribute = "Status";
    statusChangeAudit.oldValue = this.selectedRequest.status;
    statusChangeAudit.newValue = "Cancelled";

    auditData.push(statusChangeAudit);
    
      this._dataContextService.postDatawithValues<any>(this.service_URL.OutwardDetails.UpdateStatus,params)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((res) => {
        if(res == 1){
          this.toast.success("Request Cancelled");
        }
        else{
          this.toast.error("Something went wrong");
        }
      },
      (err) => {
        console.log(err);
      },
      () => {
        //Saving Data in Audit Trail
      let auditParams = {
        actionPerformed : "Status Change",
        actionPerformedOn : "Outward",
        changedBy : localStorage.getItem('email'),
        dateChanged : new Date(),
        primaryKey : this.selectedRequest.serialNumber,
        generalInformation : [],
        material : [],
        statusChange: auditData
      };

        this._dataContextService.postDatawithValues<any>(this.service_URL.AuditTrail.savetransactionaudittrail,auditParams)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe((res) => {
          // console.log(res);
        },
        (err) => {
          console.log(err);
        },
        () => {
          this.modalService.hide(1);
          window.location.reload();
        })
      })
  }

}
